import SimpleAccordion from '../../../Core/Expansion/SimpleAccordion'
import React, { useState,useContext } from 'react'
import FlexView from 'react-flexview'
import { ActiveInsuranceModel } from '../../../../models/insurance-models/ActiveInsuranceModel'
import { ReactComponent as AICircle } from '../../../../assets/ai.svg';
import { ReactComponent as PersonCircle } from '../../../../assets/person_with_circle.svg';
import { Dialog } from '@material-ui/core';
import CircledPopUpFrame from '../../../Core/CircledPopUpFrame';
import { isMobile } from 'react-device-detect';
import { EventEmitterService, EventKey } from '../../../../services/EventEmitterService';
import { SkywatchDialog } from '../../../PopUps/SkywatchDialog';
import { useLocation } from 'react-router-dom';
import DataLayerService from '../../../../services/DataLayerService';
import PolicyLiabilityExtensionContext, { PolicyLiabilityExtensionContextStore, ACTIONS } from '../../../../context/PolicyLiabilityExtensionContext'
import {POLICY_MODIFICATION_CONTEXT_ACTIONS, ModificationContextStore} from '../../../../context/ModificationContext'
import { billingPeriodPretty, liabilityLimitPretty } from '../../../../services/utils'
import { LiabilityCoveragePopover } from '../../../Core/Popover/LiabilityCoveragePopover'
import { NumberOfDronesPopover } from '../../../Core/Popover/NumberOfDronesPopover'
 import './Modify.scss'

import { CustomizeNumberOfDronesSection } from "../../../Insurance/CustomizePolicySections/CustomizeNumberOfDronesSection"
import { NUMBER_OF_DRONES_QUESTION_ANSWERS } from "../../../../Constants";
import { Action } from '../../../../models/Action';


interface PolicyAdditionalInsuredSectionProps {
    insurance: ActiveInsuranceModel
}

export const ModifyNumberOfDronesOperate = ({...props}: PolicyAdditionalInsuredSectionProps) => {
    const location = useLocation()
    const liabilityExtensionContext = useContext(PolicyLiabilityExtensionContextStore)
    const modificationContext = React.useContext(ModificationContextStore) 
    const {insurance, isOpen, modificationObject, isRenewal} = props;

    const prettySubTitle = () =>{
        return `${NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['title']}/ ${NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['value']}`
    }

    React.useEffect(() => {
        let id = EventEmitterService.subscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS);

        return function cleanup () {
            EventEmitterService.unsubscribe(EventKey.LIABILITY_EXTENSION_OFFER_SUCCESS, id)
        }
    }, [])

    React.useEffect(() => {
        const error = NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['max_drones'] != 0 && modificationObject.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['max_drones']

        if(error) {
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_NUMBER_OF_DRONES_VALID, false))
        }
        else {
            modificationContext.dispatch(new Action(POLICY_MODIFICATION_CONTEXT_ACTIONS.SET_IS_NUMBER_OF_DRONES_VALID, true))
        }
    }, [modificationObject.numberOfDronesOperate,modificationObject.drones])

    return (
    <React.Fragment>
       <SimpleAccordion className='margin-top-large' 
       title={
       <FlexView column className="space-between full-width"> 
            <div className="container-number-of-drones">
            <div>Number of operating drones</div>
            <NumberOfDronesPopover disabled={!isRenewal}/> 
            {modificationObject && NUMBER_OF_DRONES_QUESTION_ANSWERS[!!modificationObject ? 0 : modificationObject.numberOfDronesOperate]['max_drones'] != 0 && modificationObject.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['max_drones'] && <div className='red'>*</div>}
            </div>
            <div className="grey text-small">{prettySubTitle()}</div>
       </FlexView>}
            content={
                <FlexView column>
                    <div className="number-of-drones-width">
                        <CustomizeNumberOfDronesSection modificationObject={modificationObject} isRenewal={isRenewal} isModify={true}/>
                    </div>
                <br/>
                    {!isRenewal&&<div className="grey text-small">The number of drones option cannot be modified after the policy was created. For more information, please contact our support team 8888-364-5033</div>}
                    </FlexView>
                }/>
    </React.Fragment>)
}